import React from 'react';
import { Input, Button, Form, Card, message, Space, Checkbox } from 'antd';
import { FormInstance } from 'antd/lib/form';
import BreadcrumbCustom from '../../components/widget/BreadcrumbCustom';
import FileService, { AddFileParam, EditFileParam, IFileInfo } from '../../service/file/FileService';
import { ADD_FILE_SUCCESS_MESSAGE, ADD_FILE_ERROR_MESSAGE, EDIT_FILE_SUCCESS_MESSAGE, 
         EDIT_FILE_ERROR_MESSAGE, GET_FILE_ERROR_MESSAGE } from '../../config/strcfg';
import FileUpload, { FileType } from '../../components/public/FileUpload';
import './page-file.less';

interface FileManagerPageState {
  loading: boolean;
  isEditMode: boolean;
  fileData: IFileInfo;
  uploadLogoUrl: String;
  deleteLogo: boolean;
}

class FileManagerPage extends React.Component<FileManagerPageState> {
  state : FileManagerPageState = {
    loading: false,
    isEditMode: false,
    fileData: null,
    uploadLogoUrl: null,
    deleteLogo: false,
  };
  
  async componentDidMount() {
    //根据url判断展示添加or编辑页面模式
    const searchParams = new URLSearchParams(window.location.hash.split('?')[1]);
    const fileId = parseInt(searchParams.get('id'));

    //编辑文件信息页面模式
    if(fileId){
      this.setState({ isEditMode: true, loading: true });
      //编辑页面需要调用文件信息查询接口
      try{
        const response = await FileService.getFileById(fileId);
        if(response && response.data && response.data.fileInfo){
          this.setState({ fileData:response.data.fileInfo, loading: false }); 
          // 在此处添加条件判断，确保fileData有值之后再设置value属性
          if (this.state.fileData) {
            this.formRef.current?.setFieldsValue({ 
              name: this.state.fileData.name,
              originName: this.state.fileData.originName,
              url: this.state.fileData.url,
              format: this.state.fileData.format,
              size: this.state.fileData.size,
              time: this.state.fileData.time,
              dragForbidden: this.state.fileData.dragForbidden,
            });
          }
          else{
            this.setState({ FileData: null });
            message.error(GET_FILE_ERROR_MESSAGE);
          }
        }
        else{
          this.setState({ FileData: null });
          message.error(GET_FILE_ERROR_MESSAGE);
        }
      } catch(error){
        message.error(GET_FILE_ERROR_MESSAGE);
      } finally{
        this.setState({ loading: false });
      }
    }
    //添加文件信息页面模式
    else{
      this.setState({ isEditMode: false });
    }
  }

  formRef = React.createRef<FormInstance>();

  //权限选择框事件处理(不写这个空方法会导致页面任何操作都会使RoleSelect执行useEffect的接口调用)
  handleRoleSelectData = () => {
  };

  onFinish = async (params: any) => {
    this.setState({ loading: true });
    //调用addFile接口
    if(!this.state.isEditMode){
      try {
        const response = await FileService.addFile(params as AddFileParam);
        if(response && response.success){
          // 添加成功后的操作
          this.formRef.current?.resetFields();
          message.success(ADD_FILE_SUCCESS_MESSAGE);
        }
        else{
          // 添加失败后的操作
          message.error(response.message);
        }
      } catch (error) {
          message.error(ADD_FILE_ERROR_MESSAGE);
      } finally {
          this.setState({ loading: false });
      }
    }
    //调用editFile接口
    else{
      try {
        const updatedParams = {
          ...params,  
          id: this.state.fileData.id  
        };
        const response = await FileService.editFile(updatedParams as EditFileParam);
        if(response && response.success){
          // 编辑成功后的操作
          this.formRef.current?.resetFields();
          message.success(EDIT_FILE_SUCCESS_MESSAGE);
          // 在提交表单后等待500ms再刷新页面，加载提交后的数据
          setTimeout(() => { window.location.reload(); }, 500);
        }
        else{
          // 编辑失败后的操作
          this.formRef.current?.resetFields();
          message.error(response.message);
          setTimeout(() => { window.location.reload(); }, 500);
        }
      } catch (error) {
          this.formRef.current?.resetFields();
          message.error(EDIT_FILE_ERROR_MESSAGE);
          setTimeout(() => { window.location.reload(); }, 500);
      } finally {
          this.setState({ loading: false });
      }
    }
    
  };

  render() {
    const curformRef = this.formRef.current;
    //form 初始值
    const initialValues = {
    };

    const getFileInfo = (data) => {
      if(data){
        this.setState({ uploadLogoUrl: data.url });  
        return data.url;
      }
      else{
        this.setState({ uploadLogoUrl: null });  
        return null;
      }
    };

    //Upload控件onRemove事件handler
    const handleUploadRemove = () => {
      this.setState({ uploadLogoUrl: null });
      //清除form中的logo url
      curformRef.setFieldsValue({
        logo: null
      });
    }

    //删除已上传的logo
    const handleDeleteLogo = (e) => {
      this.setState({ deleteLogo: true });
      e.preventDefault(); 
      //清除form中的logo url
      curformRef.setFieldsValue({
        logo: ""
      });
    }

    const cardTitle = this.state.isEditMode ? "编辑文件信息" : "添加文件信息"; 
    return (
      this.state.loading === false ?
        <div className="page-file_container">
          <BreadcrumbCustom breads={['文件信息信息管理', this.state.isEditMode ? '编辑文件信息' : '添加文件信息']} />
          <Card title={cardTitle} bordered={false}>
              <div className="add-file_container">
                  <Form ref={this.formRef} onFinish={this.onFinish} initialValues={initialValues}>
                    <Form.Item label="文件名" name="name" className="formItem-name" rules={[{ required: true, message: '请输入文件名' }]}>
                      <Input placeholder="请输入文件名" autoComplete="off" />
                    </Form.Item>

                    <Form.Item label="原始文件名" name="originName" className="formItem-originName" rules={[{ required: true }]} >
                      <Input autoComplete="off" disabled />
                    </Form.Item>

                    <Form.Item label="文件地址" name="url" className="formItem-url" rules={[{ required: true }]} >
                      <Input autoComplete="off" disabled />
                    </Form.Item>

                    <Form.Item label="文件类型" name="format" className="formItem-format" rules={[{ required: true }]} >
                      <Input autoComplete="off" disabled />
                    </Form.Item>

                    <Form.Item label="文件大小" name="size" className="formItem-size" rules={[{ required: false }]} >
                      <Space>
                        <Input autoComplete="off" disabled />
                        <label>bytes</label> 
                      </Space>
                    </Form.Item>

                    <Form.Item label="时长" name="time" className="formItem-time" rules={[{ required: false }]} >
                      <Space>
                        <Input autoComplete="off" />
                        <label>秒</label> 
                      </Space>
                    </Form.Item>

                    <Form.Item label="屏蔽拖拽" name="dragForbidden" className="formItem-dragForbidden" rules={[{ required: false }]} >
                      <Checkbox />
                    </Form.Item>

                    <Form.Item label="文件" name="file" className="formItem-file" 
                               rules={[{ required: false }]}
                               getValueFromEvent={getFileInfo}
                    >                   
                      <FileUpload 
                        fileType={FileType.defualt}
                        onRemove={handleUploadRemove}
                      />
                    </Form.Item>

                    {this.state.fileData && this.state.fileData.url &&( 
                      <div className="div-logo">
                        <img className="img-logo" src={process.env.REACT_ADMIN_ENV + this.state.fileData.url} alt="" />
                        <p> <label> {this.state.fileData.url} </label> </p>
                        <p> <button onClick={handleDeleteLogo}>删除文件</button> </p>
                      </div>
                    )}

                    <Form.Item>
                      <Button type="primary" className="button-file_submit" htmlType="submit" loading={this.state.loading} >
                        提交
                      </Button>
                    </Form.Item>
                  </Form>
              </div>   
          </Card>
        </div> : ""
    ); 
  }
}

export default FileManagerPage;